<div class="form-group" [class.permit-form]="templateForPermitForm">
  <wm-help-text
    *ngIf="de.instructions"
    [helpText]="de.instructions"
    placement="right"
  ></wm-help-text>
  <div [innerHTML]="de.renderedHtml"></div>
</div>
